import React from 'react'

import './styles.scss'

function TableButton({ text, onClick, disabled = false }) {
    return (
        <div className={disabled ? 'table-orange-button-disabled' : 'table-orange-button'} onClick={!disabled && onClick}>
            {text}
        </div>
    )
}

export default TableButton
